<template>
 <div class="pb100">
   <volunteerdata/>
   <crumbs/>
   <div class="container">
     <el-button type="primary" @click="registerVolunteer">志愿者注册</el-button>
     <type-screen
       modelType="volunteer"
       :menu-id="this.$route.query.columnId"
       @typedata="typeDataList"
       @typeObj="selectType"/>
     <ul class="ul-model7 clearfix">
       <li v-for="(item, index) in List" :key="index">
         <router-link :to="'/volunteerdetail?columnId=' + item.menuId + '&id=' + item.id">
           <div class="imgbox">
             <img class="imgcover" :src="item.image" alt="">
           </div>
           <div class="txtbox">
             <h2>{{ item.name }}</h2>
             <p class="textover">服务时长：<span>{{ item.serviceTime }}</span></p>
             <p class="textover">活动次数：<span>{{ item.activityNum }}</span></p>
             <p class="textover">服务类别：<span>{{ item.serviceTypeName }}</span></p>
           </div>
         </router-link>
       </li>
     </ul>
     <nodata v-show="nodataflag"/>
     <el-pagination
       v-show="!nodataflag"
       @current-change="handleCurrentChange"
       :page-size="Param.limit"
       :pager-count="5"
       :current-page.sync="currentPage"
       layout="prev, pager, next"
       :total="listTotal"
       class="pagemodel1">
     </el-pagination>
     <registervolunteer
        :menuId="menuId"
       :centerDialogVisible="showregister"
       :politicalStateArr="politicalStateArr"
       :serviceTypeArr="serviceTypeArr"
       :serviceAreaArr="serviceAreaArr"/>
   </div>
 </div>
</template>

<script>
import volunteerdata from '@/view/volunteercenter/volunteerdata'
import crumbs from '@/components/crumbs/index'
import typeScreen from '@/components/typescreen/index'
import { isVolunteer, VolunteerList } from '@/api/volunteer/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import registervolunteer from '@/view/volunteercenter/registervolunteer'
export default {
  name: 'volunteer',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    volunteerdata,
    nodata,
    registervolunteer
  },
  data () {
    return {
      nodataflag: false,
      Param: {
        fid: this.$cookie.get('culturalCloud_fid'),
        pageNum: 1,
        limit: 12,
        type: '',
        politicalState: '',
        serviceType: '',
        serviceArea: '',
        menuId: this.$route.query.columnId
      },
      currentPage: 1,
      List: [],
      listTotal: 0,
      showregister: false,
      politicalStateArr: [],
      serviceTypeArr: [],
      serviceAreaArr: [],
      menuId: this.$route.query.columnId
    }
  },
  created () {
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    getList () {
      VolunteerList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.politicalState = obj.politicalState
      this.Param.serviceType = obj.serviceType
      this.Param.serviceArea = obj.serviceArea
      this.Param.type = obj.customTypeId
      this.Param.pageNum = 1
      this.currentPage = 1
      this.getList()
    },
    typeDataList (val) {
      this.volunteertypeArr = val.dictType
      if (this.volunteertypeArr['zyzzzmm'].list.length > 0) {
        Object.assign(this.politicalStateArr, this.volunteertypeArr['zyzzzmm'].list)
      }
      if (this.volunteertypeArr['zyzfwlx'].list.length > 0) {
        Object.assign(this.serviceTypeArr, this.volunteertypeArr['zyzfwlx'].list)
      }
      if (this.volunteertypeArr['zyzfwqy'].list.length > 0) {
        Object.assign(this.serviceAreaArr, this.volunteertypeArr['zyzfwqy'].list)
      }
    },
    /* 注册志愿者按钮 */
    registerVolunteer () {
      isVolunteer(this.$cookie.get('culturalCloud_fid')).then(res => {
        if (res.data.rel) {
          this.showregister = true
          this.$message({
            message: '您已注册',
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/volunteerlist.vue